import { Alert, Link } from '@mm/components';
import { useUsersCRUDActions } from '@mm/state/actions/UsersCRUDActions';
import { OneTimeAlertType } from '@mm/state/model/CompanyUsersModel';
import {
  oneTimeAlertsSeenSelector,
  selectCurrentUserId,
} from '@mm/state/selectors/userSelector';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './November2020EuroAdsChangesAlert.module.css';

const ALERT_TYPE: OneTimeAlertType = 'november_2020_euro_ads_changes_alert';

export const November2020EuroAdsChangesAlert = () => {
  const companyId = useSelector(selectActiveCompanyId);
  const currentUserId = useSelector(selectCurrentUserId);
  const alertsSeen = useSelector(oneTimeAlertsSeenSelector);

  const { updateUserAttributes } = useUsersCRUDActions();

  const dismissAlert = async () => {
    await updateUserAttributes(companyId, currentUserId, {
      oneTimeAlertsSeen: { ...alertsSeen, [ALERT_TYPE]: true },
    });
  };
  if (alertsSeen[ALERT_TYPE]) {
    return null;
  }

  return (
    <Alert
      className={styles.alert}
      type="warning"
      closeIconProps={{
        onClick: dismissAlert,
        className: styles.close_button,
      }}
    >
      <span className={classNames(styles.bold, styles.underline)}>
        Starting November 16, 2020
      </span>{' '}
      Facebook will enforce new rules for{' '}
      <span className={styles.bold}>
        ads run by European advertisers or ads targeting people in Europe
      </span>
      . Your ads campaign may be paused if it does not meet these new
      requirements. Click{' '}
      <Link
        className={styles.link}
        isBlank
        href="https://mobilemonkey.com/help/article/28zigp706a-updated-facebook-ads-policies-effective-11-16-2020"
      >
        here
      </Link>{' '}
      for more information.
    </Alert>
  );
};
